import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Col, FormGroup, Input, Row } from "reactstrap";
import ItemCounter from "./ItemCounter";
import cash from "../assets/img/cash 1.svg";
import card from "../assets/img/PaymentCard.png";
import { deleteCartAction, updateAddOns } from "../store/actions/cartAction";
import pizzalabel from "../assets/img/pizzalabel.svg";
import { FaTrashAlt } from "react-icons/fa";
import { SiWebmoney } from "react-icons/si";
import AddonCounter from "./AddOnCounter";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

const OrderedItems = ({ data, title }) => {
  const location = useLocation();
  const pathName = location.pathname;
  const isTrackingPage = pathName.includes("/tracking");
  const { darkMode, color } = useSelector((state) => state.global);
  const capitalizeWords = (str) =>
    str?.replace(/\b\w/g, (char) => char.toUpperCase()) || "";
  const dispatch = useDispatch();

  return (
    <>
      {title !== "Payment Info" ? (
        <>
          <Row className="d-flex flex-column mt-4">
            <Col>
              <h4
                className={
                  darkMode
                    ? "text-capitalize fs--18 fw--600 mb-0  normal-heading-dark"
                    : "text-capitalize fs--18 fw--600 mb-0  normal-heading"
                }
              >
                {title}
              </h4>
            </Col>
            <Col
              className={
                pathName === "/tracking" && darkMode
                  ? "bg-transparent mt-3"
                  : darkMode
                  ? "bg-site-transparent mt-3"
                  : "bg-site-transparent mt-3"
              }
            >
              {Array.isArray(data) &&
                data?.map((item, index) => {
                  const isOffer = item?.type === "offer";

                  return (
                    <div
                      key={index}
                      className={`position-relative ordered-item-container d-flex flex-column flex-md-row gap-3 mt-3 p-3 rounded mb-4 ${
                        darkMode ? "bg-site-transparent text-white" : "bg-white"
                      }`}
                      style={{
                        boxShadow: darkMode
                          ? "0 0 10px rgba(255, 255, 255, 0.2)"
                          : "0 0 10px rgba(0, 0, 0, 0.2)",
                        minHeight: "150px",
                      }}
                    >
                      <div className="flex-shrink-0 text-center mb-4 mb-md-0">
                        {Array.isArray(item?.images) &&
                        item.images?.length <= 1 ? (
                          <img
                            src={item?.images?.[0] || pizzalabel}
                            alt={item?.name}
                            style={{
                              width: "150px",
                              height: "160px",
                              borderRadius: "10px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <Swiper
                            modules={[Autoplay]}
                            autoplay={{
                              delay: 2500,
                              disableOnInteraction: false,
                            }}
                            loop={true}
                            spaceBetween={10}
                            slidesPerView={1}
                            style={{
                              width: "150px",
                              height: "160px",
                              borderRadius: "10px",
                              overflow: "hidden",
                            }}
                          >
                            {(isOffer
                              ? Array.isArray(item.images)
                                ? item.images
                                : [item.images]
                              : Array.isArray(item?.images)
                              ? item.images
                              : []
                            ).map((img, idx) => (
                              <SwiperSlide key={idx}>
                                <img
                                  src={img}
                                  alt={`slide-${idx}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                  }}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        )}
                      </div>

                      <div className="w-100 ml-3 mb-4">
                        <div className="d-flex justify-content-between align-items-start flex-wrap">
                          <div className="d-flex flex-column justify-content-start align-items-start text-start">
                            <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                              <h5 className="fw-bold mb-0">
                                {capitalizeWords(item?.name)}
                              </h5>
                              {item.type === "offer" && (
                                <div
                                  className="d-flex align-items-center gap-1 ml-4 px-3 py-1 rounded-pill text-white"
                                  style={{
                                    background:
                                      "linear-gradient(90deg, #ff4e50, #f9d423)",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                                  }}
                                >
                                  Special Offer
                                </div>
                              )}
                            </div>
                            {!isOffer && (
                              <p className="text-muted mb-1">
                                Size:{""} {item?.size}
                              </p>
                            )}
                            <p className="fw-semibold mb-0">
                              Price: {item.currency || "$"}{" "}
                              <span className="text-success">{item.price}</span>
                            </p>
                          </div>

                          {!isTrackingPage && (
                            <div className="d-flex flex-column align-items-center gap-2 mt-1">
                              <div className="d-flex align-items-center mb-2">
                                <FaTrashAlt
                                  size={18}
                                  onClick={() =>
                                    dispatch(deleteCartAction(item))
                                  }
                                  className="ml-2 text-danger cursor-pointer"
                                />
                              </div>
                              <ItemCounter cartItem={item} type="cart" />
                            </div>
                          )}
                        </div>

                        {(isOffer ? item.cartItems : item.addons)?.length >
                          0 && (
                          <div className="row gx-3 gy-3 mt-2">
                            {(isOffer ? item.cartItems : item.addons)?.map(
                              (entry) => (
                                <div
                                  key={entry.id}
                                  className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3"
                                >
                                  <div
                                    className={`p-2 h-100 d-flex flex-column justify-content-between ${
                                      darkMode ? "shadow-white" : "shadow-dark"
                                    }`}
                                    style={{
                                      borderRadius: "8px",
                                      boxShadow: darkMode
                                        ? "0 0 10px rgba(255, 255, 255, 0.2)"
                                        : "0 0 10px rgba(0, 0, 0, 0.2)",
                                    }}
                                  >
                                    <div className="d-flex align-items-center mb-2">
                                      <img
                                        src={entry.image}
                                        alt={
                                          isOffer ? entry.itemName : entry.name
                                        }
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "6px",
                                        }}
                                      />

                                      <div className="ms-2 ml-2 flex-grow-1 overflow-hidden">
                                        <h6
                                          className="mb-1 text-truncate"
                                          style={{ maxWidth: "100%" }}
                                          title={
                                            isOffer
                                              ? entry.itemName
                                              : entry.name
                                          }
                                        >
                                          {capitalizeWords(
                                            isOffer
                                              ? entry.itemName
                                              : entry?.name
                                          )}
                                        </h6>
                                        {isOffer && entry.variant && (
                                          <p
                                            className="mb-0"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Variant: {entry.variant}
                                          </p>
                                        )}
                                        <p
                                          className="mb-0 text-muted"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Quantity: {entry.quantity}
                                        </p>
                                        {!isOffer && (
                                          <p
                                            className="mb-0"
                                            style={{ fontSize: "14px" }}
                                          >
                                            Price: {item.currency || "$"}
                                            <span className="text-success fw-bold">
                                              {" "}
                                              <span className="text-sm font-medium text-gray-700">
                                                {entry.price === 0
                                                  ? "Free"
                                                  : entry.price *
                                                    entry.quantity}
                                              </span>
                                            </span>
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    {!isTrackingPage && !isOffer && (
                                      <div className="d-flex justify-content-center mt-2">
                                        <AddonCounter
                                          quantity={entry.quantity}
                                          price={entry.price}
                                          darkMode={darkMode}
                                          onChange={(newQuantity) => {
                                            const updatedAddons = item.addons
                                              .map((a) =>
                                                a.id === entry.id
                                                  ? {
                                                      ...a,
                                                      quantity: newQuantity,
                                                    }
                                                  : a
                                              )
                                              .filter((a) => a.quantity > 0);

                                            const updatedItem = {
                                              ...item,
                                              addons: updatedAddons,
                                              totalPrice:
                                                item.price * item.quantity +
                                                updatedAddons.reduce(
                                                  (sum, a) =>
                                                    sum + a.price * a.quantity,
                                                  0
                                                ),
                                            };
                                            dispatch(updateAddOns(updatedItem));
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}

                        <div
                          className="position-absolute d-flex align-items-center gap-2"
                          style={{
                            bottom: "10px",
                            right: "16px",
                          }}
                        >
                          <SiWebmoney style={{ color, fontSize: "1.25rem" }} />
                          <h5 className="mb-0">
                            <span className="me-1 fw-600">Item Total: </span>
                            {item.currency || "$"}
                            <span className="text-success fw-bold">
                              {item.totalPrice}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Col>
          </Row>
        </>
      ) : (
        <>
          {}
          <Col
            className={
              pathName === "/tracking" && darkMode
                ? "bg-transparent mt-3"
                : darkMode
                ? "bg-site-black mt-3"
                : "bg-site-white mt-3"
            }
          >
            <div className=" py-3 d-flex align-items-start cart__shipping">
              {data === "Paypal" || data === "Stripe" ? (
                <img alt="Payment" src={card} className="PaymentCard" />
              ) : (
                <img alt="Payment" className="PaymentCard" src={cash} />
              )}
              <div className="mx-3 w-100">
                <h4 className="fs--18 text-muted fw--500 text-capitalize">
                  Payment Method
                </h4>

                {}
                <h4
                  className={
                    darkMode
                      ? "fs--18 fw--600 normal-heading-dark"
                      : "fs--18 fw--600"
                  }
                >
                  {data ? data : ""}
                </h4>

                {data?.content && (
                  <FormGroup
                    className={
                      darkMode
                        ? "top_cards-dark__textarea"
                        : "top_cards__textarea"
                    }
                  >
                    <Input
                      type="textarea"
                      name="text"
                      id="exampleText"
                      placeholder={data.content}
                      defaultValue={data.content}
                      rows={4}
                      cols={40}
                      disabled
                    />
                  </FormGroup>
                )}
                {title !== "Payment Info" && title !== "Order Info" && (
                  <div className="d-flex justify-content-end align-items-center mr-5">
                    {}
                    <i className="fas fa-trash-alt fa-2x text-danger pointer"></i>
                  </div>
                )}
              </div>
            </div>
          </Col>
          {}
        </>
      )}
    </>
  );
};

export default OrderedItems;
